import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { IMessage } from 'types/order/documents/IMessage';
import { Notification } from 'ui-toolkit';

export interface IMessageDisplayProps {
  message?: IMessage;
}

export const MessageDisplay: React.FC<IMessageDisplayProps> = ({ message }) => {
  const targetElement = document.getElementById('cpl-message-target');
  useEffect(() => {
    if (message && targetElement) {
      window.scrollTo(0, 0);
    }
  }, [message, targetElement]);
  if (!message || !targetElement) {
    return <></>;
  }

  return ReactDOM.createPortal(<Notification type={message.type} message={message.text} />, targetElement);
};
